import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {AlertService} from '../../services/alert/alert.service';
import {LoadingService} from '../../services/loading/loading.service';
import {DataService} from '../../services/data.service';
import {
  FrtRatesBidcycles,
  RateTypesSroPojo,
  FrtAcessorialsMaster,
  FrtRatesBidcyclesSros,
  FrtAccessorialMandatory
} from 'src/app/shared/common-components/common-structure';
import {FrtRatesBidcyclesService} from 'src/app/services/frt-rates-bidcycles/frt-rates-bidcycles.service';
import {RateTypesSroService} from 'src/app/services/rate-types-sro/rate-types-sro.service';
import {FrtAccessorialsMasterService} from 'src/app/services/frt-accessorials-master/frt-accessorials-master.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ExtendExpiryDatesComponent} from '../extend-expiry-dates/extend-expiry-dates.component';
import {RatefileOpenService} from 'src/app/services/ratefile-open/ratefile-open.service';
import {ControlKeys} from '../ratefile-open/control-keys';
import {ConfirmationModalComponent} from '../../shared/common-components/confirmation-modal/confirmation-modal.component';
import AppConstants from '../../shared/common-components/AppConstants';
import { FrtRatesBidcyclesDuplicateButtonRendererComponent } from './frt-rates-bidcycles-duplicate-button-renderer.component';
import moment from 'moment';
import { CommonValidators } from 'src/app/shared/common-components/common-validators';

@Component({
    selector: 'app-frt-rates-bidcycles',
    templateUrl: './frt-rates-bidcycles.component.html',
    styleUrls: ['./frt-rates-bidcycles.component.css'],
    standalone: false
})
export class FrtRatesBidcyclesComponent implements OnInit {

  frtRatesBidcyclesForm: UntypedFormGroup;
  frtRatesBidcycles: FrtRatesBidcycles;
  public modalRef: BsModalRef;
  bsModalRef: BsModalRef;
  openMinDate: Date;
  closeMinDate: Date;
  bidOpenMinDate: Date;
  bidCloseMinDate: Date;
  tspOpenMinDate: Date;
  tspCloseMinDate: Date;
  effOpenMinDate: Date;
  effCloseMinDate: Date;
  allSros: RateTypesSroPojo[];
  sroListByRateType: RateTypesSroPojo[];
  assignedSroList: RateTypesSroPojo[];
  frtAccMasterList: FrtAcessorialsMaster[];
  assignedAccList: FrtAcessorialsMaster[];
  selectedSroList: FrtRatesBidcyclesSros[];
  selectedAccList: FrtAccessorialMandatory[];
  assignedSroMasterIds: number[];
  assignedAccessorailMasterIds: number[];
  rateBidcyclesList: FrtRatesBidcycles[];
  itemsPerPage = 10;
  bidcycleError: boolean;
  bidOpenDateError: boolean;
  bidOpenDateErrorType: string;
  bidCloseDateError: boolean;
  bidCloseDateErrorType: string;
  tspOpenDateError: boolean;
  tspOpenDateErrorType: string;
  tspCloseDateError: boolean;
  tspCloseDateErrorType: string;
  effOpenDateError: boolean;
  effOpenDateErrorType: string;
  effCloseDateError: boolean;
  effCloseDateErrorType: string;
  errorMessage: string;
  disableUpdate: boolean;
  isError: boolean;
  disableCreateBtn: boolean;
  updateAction: string;
  assignedIds: any[];
  pcMilerList: ControlKeys[];
  showProduction: Boolean = false;
  showPublish: Boolean = false;
  fuelSurList: ControlKeys[];
  disabled: boolean;
  disableUpdateButton: boolean;
  updateBtnText: string;
  gridApi:any;
  domLayout:any;
  rateBidcyclesColumnDefs = [
    {
      headerName: 'Bidcycle Name', field: 'bidCycleName', width: 150,
      cellRenderer: params =>
        '<a tabindex="0">' + params.data.bidCycleName + '</a>',
      onCellClicked: event => this.onbidCycleNameSelected(event.data)
    },
    {
      headerName: 'Rate Filing Open Date', field: 'bidWindowOpenDate', width: 180, filter: 'agTextColumnFilter', sortable: true,
      cellRenderer: (data) => {
        return data.value ? (new Date(data.value)).toLocaleDateString() : '';
      }
    },
    {
      headerName: 'Rate Filing Close Date', field: 'bidWindowCloseDate', width: 180, filter: 'agTextColumnFilter', sortable: true,
      cellRenderer: (data) => {
        return data.value ? (new Date(data.value)).toLocaleDateString() : '';
      }
    },
    {
      headerName: 'Rate Effective Date', field: 'rateEffectiveDate', width: 160, filter: 'agTextColumnFilter', sortable: true,
      cellRenderer: (data) => {
        return data.value ? (new Date(data.value)).toLocaleDateString() : '';
      }
    },
    {
      headerName: 'Rate Expiry Date', field: 'rateExpiryDate', width: 160, filter: 'agTextColumnFilter', sortable: true,
      cellRenderer: (data) => {
        return data.value ? (new Date(data.value)).toLocaleDateString() : '';
      }
    },
    {
      headerName: 'TSP Participation Open Date', field: 'tspParticipationOpenDate', width: 150, filter: 'agTextColumnFilter', sortable: true,
      cellRenderer: (data) => {
        return data.value ? (new Date(data.value)).toLocaleDateString() : '';
      }
    },
    {
      headerName: 'TSP Participation End Date', field: 'tspParticipationCloseDate', width: 150, filter: 'agTextColumnFilter', sortable: true,
      cellRenderer: (data) => {
        return data.value ? (new Date(data.value)).toLocaleDateString() : '';
      }
    },
    {
      headerName: 'Release to Prod Date', field: 'releaseDateProduction', filter: 'agTextColumnFilter', sortable: true,
      cellRenderer: (data) => {
        return data.value ? (new Date(data.value)).toLocaleDateString() : '';
      }
    },
    {
      headerName: 'Duplicate Rate Filling', field: '', filter: '', sortable: true,
      cellRenderer: FrtRatesBidcyclesDuplicateButtonRendererComponent,
      cellRendererParams: {
        onClick: this.onDuplicatedBidCycle.bind(this),
        label: 'Duplicate Rate'
      },
    }
  ];

  showResetBidCycle: boolean = false;

  listHrs: {key: String, value:String}[] = [];
  frtBidCycleClosedDate: Boolean = false;
  onDupplicateBtn(data: any){
    console.log(data);
  }

  constructor(
    private frtRatesBidcyclesService: FrtRatesBidcyclesService,
    private fb: UntypedFormBuilder,
    private alertService: AlertService,
    private tmssLoader: LoadingService,
    private rateTypesSroService: RateTypesSroService,
    private frtAccessorialsMasterService: FrtAccessorialsMasterService,
    private modalService: BsModalService,
    private ratefileOpenService: RatefileOpenService
  ) {
  }

  ngOnInit() {
    this.domLayout = 'autoHeight';
    this.frtAccessorialsMasterService.getUniqueAccessorials().subscribe(
      FrtAcessorials => {
        this.frtAccMasterList = FrtAcessorials;
      }, error => {
        this.alertService.error('Error while getting accessorial types. Please contact system administrator');
      });

    this.frtRatesBidcyclesService.getAll().subscribe(
      rateBidcyclesList => {
        this.rateBidcyclesList = rateBidcyclesList;
      }, error => {
        this.alertService.error('Error while retrieving Rate Bidcycles List');
      });

    this.rateTypesSroService.getAllSros().subscribe(
      sroList => {
        this.allSros = sroList;
      }, error => {
        this.alertService.error('There was an error retrieving all SRO List');
      });

    this.ratefileOpenService.getRateFileRecordForControlType('FRT PCMiler Version').subscribe(pcMilerList => {
      this.pcMilerList = pcMilerList;
    }, error => {
      this.alertService.error('There was an error retrieving PcMiler Versions');
    });

    this.ratefileOpenService.getRateFileRecordForControlType('Fuel Surcharge').subscribe(fuelSurList => {
      this.fuelSurList = fuelSurList;
    }, error => {
      this.alertService.error('There was an error retrieving Fuel Surcharge list');
    });
    this.initValues();
    this.createForm();
    this.resetForm();
    this.generateHours();
    this.initCurrentTime();
    this.combineDateandTime();
  }

  initValues() {
    this.updateAction = 'create';
    this.updateBtnText = 'Save';
    this.disableUpdate = true;
    this.disableCreateBtn = false;
    this.disabled = false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    this.bidOpenMinDate = today;
    this.bidCloseMinDate = today;
    this.tspOpenMinDate = today;
    this.tspCloseMinDate = today;
    this.effOpenMinDate = today;
    this.effCloseMinDate = today;
  }

  handleSroMultiDropdown(i: any) {
    if (!this.disabled) {
      this.assignedSroList.splice(i, 1);
    }
  }

  handleAccMultiDropdown(i: any) {
    if (!this.disabled) {
      this.assignedAccList.splice(i, 1);
    }
  }

  createForm() {
    this.frtRatesBidcyclesForm = this.fb.group({
      ratesBidcyclesId: new UntypedFormControl('', [Validators.required]),
      allSros: new UntypedFormControl('', [Validators.required]),
      assignedSros: new UntypedFormControl('', [Validators.required]),
      allAccessorials: new UntypedFormControl('', [Validators.required]),
      assignedAccessorials: new UntypedFormControl('', [Validators.required]),
      bidCycle: new UntypedFormControl('', [Validators.required]),
      bidOpenDate: new UntypedFormControl('', [Validators.required]),
      // bidCloseDate: new UntypedFormControl('', [Validators.required]),
      bidCloseDate: new UntypedFormControl({value: moment().format('MM/DD/YYYY'), disabled: true},[Validators.required, CommonValidators.usDate]),
      timeSelection: new UntypedFormControl('',[Validators.required]),
      tspOpenDate: new UntypedFormControl('', [Validators.required]),
      tspCloseDate: new UntypedFormControl('', [Validators.required]),
      effOpenDate: new UntypedFormControl('', [Validators.required]),
      effCloseDate: new UntypedFormControl('', [Validators.required]),
      pcMiler: new UntypedFormControl('', [Validators.required]),
      fuelSur: new UntypedFormControl('', [Validators.required]),
      ltlBase: new UntypedFormControl('', [Validators.required]),
      addlText: new UntypedFormControl('', [Validators.maxLength(500)])
    });
  }

  resetForm() {
    this.updateAction = 'create';
    this.updateBtnText = 'Save';
    this.disableCreateBtn = false;
    this.disableUpdateButton = false;
    this.clearErrors();
    this.showPublish = false;
    this.assignedSroList = [];
    this.assignedAccList = [];
    this.frtRatesBidcyclesForm.controls['ratesBidcyclesId'].setValue(0);
    this.frtRatesBidcyclesForm.controls['bidCycle'].setValue('');
    this.frtRatesBidcyclesForm.controls['bidCycle'].enable();
    this.frtRatesBidcyclesForm.controls['bidOpenDate'].setValue(new Date());
    this.frtRatesBidcyclesForm.controls['bidCloseDate'].setValue(moment().format('MM/DD/YYYY'));
    this.generateHours();
    this.initCurrentTime();
    this.frtRatesBidcyclesForm.controls['allSros'].setValue('');
    this.frtRatesBidcyclesForm.controls['allAccessorials'].setValue('');
    this.frtRatesBidcyclesForm.controls['assignedSros'].setValue('');
    this.frtRatesBidcyclesForm.controls['assignedAccessorials'].setValue('');
    this.frtRatesBidcyclesForm.controls['tspOpenDate'].setValue('');
    this.frtRatesBidcyclesForm.controls['tspCloseDate'].setValue('');
    this.frtRatesBidcyclesForm.controls['effOpenDate'].setValue('');
    this.frtRatesBidcyclesForm.controls['effCloseDate'].setValue('');
    this.frtRatesBidcyclesForm.controls['pcMiler'].setValue('');
    this.frtRatesBidcyclesForm.controls['fuelSur'].setValue('');
    this.frtRatesBidcyclesForm.controls['ltlBase'].setValue('1');
    this.frtRatesBidcyclesForm.controls['addlText'].setValue('');
    this.enableForm();
    this.clearValidators();
  }

  saveRateFileRec() {
    this.validateBidRecord();
    if (this.disableUpdate == true) {
      return;
    }
    this.populateBidRecord();
    (this.frtRatesBidcyclesForm.controls['ratesBidcyclesId'].value == 0) ?
      this.createRateFile() : this.updateRateFile();
  }

  updateRateFile() {
    this.tmssLoader.show();
    this.frtRatesBidcyclesService.updateRatesBidcycles(this.frtRatesBidcycles)
      .subscribe(data => {
          this.alertService.success('Rates Bidcycles has been updated');
          this.disableCreateBtn = true;
          this.frtRatesBidcyclesService.getAll().subscribe(
            rateBidcyclesList => {
              this.rateBidcyclesList = rateBidcyclesList;
            }, error => {
              this.alertService.error('Error while retrieving Rate Bidcycles List');
            });
          this.tmssLoader.hide();
        },
        (error) => {
          this.alertService.error('There was an error while updating rates bidcycles');
          this.tmssLoader.hide();
        });


  }

  createRateFile() {
    this.bsModalRef = this.modalService.show(ConfirmationModalComponent);
    this.bsModalRef.content.question = 'You are about to open a rate bidcycle. Please click ok to continue or  cancel to go back.';
    this.bsModalRef.content.title = 'Open Rate Filing Window';
    this.bsModalRef.content.confirmText = 'Ok';
    this.bsModalRef.content.cancelText = 'Cancel';
    this.bsModalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        this.tmssLoader.show();
        this.frtRatesBidcyclesService.createRatesBidcycles(this.frtRatesBidcycles)
          .subscribe(data => {
              this.alertService.success('Rates Bidcycles has been created');
              this.disableCreateBtn = true;
              this.frtRatesBidcyclesService.getAll().subscribe(
                rateBidcyclesList => {
                  this.rateBidcyclesList = rateBidcyclesList;
                }, error => {
                  this.alertService.error('Error while retrieving Rate Bidcycles List');
                });
              this.tmssLoader.hide();
              this.showPublish = true;
            },
            (error) => {
              console.log('There was an error while creating rates bidcycles' + JSON.stringify(error));
              this.alertService.error('There was an error while creating rates bidcycles');
              this.tmssLoader.hide();
            });
      }
    }, () => {
      this.alertService.warn('Opening a rate bidcycle has been cancelled.');
    });
  }

  validateBidRecord() {
    const bidCycleName = this.frtRatesBidcyclesForm.controls['bidCycle'].value;
    const bidWindowOpenDate = this.frtRatesBidcyclesForm.controls['bidOpenDate'].value;
    const bidWindowCloseDate = this.frtRatesBidcyclesForm.controls['bidCloseDate'].value;
    const tspParticipationOpenDate = this.frtRatesBidcyclesForm.controls['tspOpenDate'].value;
    const tspParticipationCloseDate = this.frtRatesBidcyclesForm.controls['tspCloseDate'].value;
    const rateEffectiveDate = this.frtRatesBidcyclesForm.controls['effOpenDate'].value;
    const rateExpiryDate = this.frtRatesBidcyclesForm.controls['effCloseDate'].value;
    const pcMiler = this.frtRatesBidcyclesForm.controls['pcMiler'].value;
    const fuelSur = this.frtRatesBidcyclesForm.controls['fuelSur'].value;
    const ltlBase = this.frtRatesBidcyclesForm.controls['ltlBase'].value;
    const addlText = this.frtRatesBidcyclesForm.controls['addlText'].value;
    this.disableUpdate = true;
    if (bidCycleName === null || bidCycleName === '') {
      this.errorMessage = 'Bid Cycle name is required.';
      this.isError = true;
      return;
    }
    if (this.bidcycleError) {
      this.errorMessage = 'Bid Cycle name is already available.Please use another name.';
      this.isError = true;
      return;
    }
    if (bidWindowOpenDate === null || bidWindowOpenDate === '') {
      this.errorMessage = 'Rate Filing Open Date is required.';
      this.isError = true;
      return;
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (bidWindowOpenDate < today && this.updateBtnText === 'Save') {
      this.errorMessage = 'Rate Filing Open Date should be on or after today.';
      this.isError = true;
    }
    if (bidWindowCloseDate === null || bidWindowCloseDate === '') {
      this.errorMessage = 'Rate Filing Close Date is required.';
      this.isError = true;
      return;
    }
    if (bidWindowOpenDate > bidWindowCloseDate) {
      this.errorMessage = 'Rate Filing Close Date should be on or after Rate Filing Open Date.';
      this.isError = true;
      return;
    }
    if (this.assignedSroList.length < 1) {
      this.errorMessage = 'Please select atleast on SRO.';
      this.isError = true;
      return;
    }
    if (this.assignedAccList.length < 1) {
      this.errorMessage = 'Please select atleast on Accessorial.';
      this.isError = true;
      return;
    }
    if (tspParticipationOpenDate === null || tspParticipationOpenDate === '') {
      this.errorMessage = ' TSP Participation Open Date is required.';
      this.isError = true;
      return;
    }
    if (tspParticipationCloseDate === null || tspParticipationCloseDate === '') {
      this.errorMessage = ' TSP Participation Close Date is required.';
      this.isError = true;
      return;
    }
    if (rateEffectiveDate === null || rateEffectiveDate === '') {
      this.errorMessage = 'Rate Effective Date is required.';
      this.isError = true;
      return;
    }
    if (rateExpiryDate === null || rateExpiryDate === '') {
      this.errorMessage = 'Rate Expiry Date is required.';
      this.isError = true;
      return;
    }
    if (pcMiler === '') {
      this.errorMessage = 'Pc Miler is required.';
      this.isError = true;
      return;
    }
    if (fuelSur === '') {
      this.errorMessage = 'Fuel SurchargeVesrion is required.';
      this.isError = true;
      return;
    }
    if (ltlBase === '') {
      this.errorMessage = 'Ltl BaseVersion is required.';
      this.isError = true;
      return;
    }
    if (addlText === '') {
      this.errorMessage = 'Additional Text is required.';
      this.isError = true;
      return;
    }
    if (addlText.length > 500) {
      this.errorMessage = 'Additional Text exceeds 500 chars.';
      this.isError = true;
      return;
    }
    this.isError = false;
    this.disableUpdate = false;
  }

  populateBidRecord() {
    this.frtRatesBidcycles = new FrtRatesBidcycles();
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    this.frtRatesBidcycles.ratesBidcyclesId = this.frtRatesBidcyclesForm.controls['ratesBidcyclesId'].value;
    this.frtRatesBidcycles.bidCycleName = this.frtRatesBidcyclesForm.controls['bidCycle'].value;
    this.frtRatesBidcycles.bidWindowOpenDate = this.frtRatesBidcyclesForm.controls['bidOpenDate'].value;
    this.frtRatesBidcycles.bidWindowCloseDate = this.combineDateandTime();

    // this.frtRatesBidcycles.bidWindowCloseDate = this.frtRatesBidcyclesForm.controls['dateSelection'].value;
    this.frtRatesBidcycles.tspParticipationOpenDate = this.frtRatesBidcyclesForm.controls['tspOpenDate'].value;
    this.frtRatesBidcycles.tspParticipationCloseDate = this.frtRatesBidcyclesForm.controls['tspCloseDate'].value;
    this.frtRatesBidcycles.rateEffectiveDate = this.frtRatesBidcyclesForm.controls['effOpenDate'].value;
    this.frtRatesBidcycles.rateExpiryDate = this.frtRatesBidcyclesForm.controls['effCloseDate'].value;
    this.frtRatesBidcycles.businessType = 'FRT';
    this.frtRatesBidcycles.updateProgram = '';
    this.frtRatesBidcycles.pcMilerVersion = this.frtRatesBidcyclesForm.controls['pcMiler'].value;
    this.frtRatesBidcycles.fuelSurchargeVersion = this.frtRatesBidcyclesForm.controls['fuelSur'].value;
    this.frtRatesBidcycles.ltlBaselineVersion = this.frtRatesBidcyclesForm.controls['ltlBase'].value;
    this.frtRatesBidcycles.additionalInformation = this.frtRatesBidcyclesForm.controls['addlText'].value;
    this.frtRatesBidcycles.updateDate = today;
    this.frtRatesBidcycles.updateId = 0;
    this.frtRatesBidcycles.userId = 0;
    this.assignedSroMasterIds = [];
    this.loadSelectedSros();
    this.frtRatesBidcycles.assignedSroMasterIds = this.assignedSroMasterIds;
    this.assignedAccessorailMasterIds = [];
    this.loadSelectedAccs();
    this.frtRatesBidcycles.assignedAccessorailMasterIds = this.assignedAccessorailMasterIds;
  }

  clearPage() {
    this.resetForm();
  }
  publishBidcycle(){
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.content.question = 'Are you sure, you want publish the current bidcycle to TSPs? Click Yes to proceed, No to go back.';
    this.modalRef.content.title = 'Publish the current bidcycle to TSPs';
    this.modalRef.content.confirmText = 'Yes';
    this.modalRef.content.cancelText = 'No';
    this.showPublish = false;
    this.populateBidRecord();
    this.frtRatesBidcycles.publishEmail = 1;
    this.modalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        this.rateBidcyclesList.forEach(bid => {
          if (bid.bidCycleName == this.frtRatesBidcycles.bidCycleName) {
            this.frtRatesBidcycles.ratesBidcyclesId = bid.ratesBidcyclesId;
            bid.publishEmail = 1;
          }
        });
        this.tmssLoader.show();
        this.frtRatesBidcyclesService.sendFrtCarrierEmails(this.frtRatesBidcycles).subscribe(res => {
          this.tmssLoader.hide();
          this.alertService.success('Emails are being sent out to TSPs.');
        }, error => {
          this.tmssLoader.hide();
          console.log(error);
          this.alertService.error('Publish Rate Bid Cycle failed');
        });
      }
    });

  }

  releaseToProduction() {
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.content.question = 'Are you sure, you want release the current bidcycle to production? Click Yes to proceed, No to go back.';
    this.modalRef.content.title = 'Release the current bidcycle to production';
    this.modalRef.content.confirmText = 'Yes';
    this.modalRef.content.cancelText = 'No';
    this.modalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        this.tmssLoader.show();
        this.frtRatesBidcyclesService.startReleaseToProduction(this.frtRatesBidcyclesForm.get('ratesBidcyclesId').value, 'FRT').subscribe(res => {
          this.tmssLoader.hide();
          this.alertService.success('Prod Carry Forward Success');
        }, error => {
          this.tmssLoader.hide();
          this.alertService.error('Error in Prod Carry Forward');
        });
      }
    });
  }

  loadSelectedSros() {
    if (this.assignedSroList.length > 0) {
      this.assignedSroList.forEach(x => {
        this.assignedSroMasterIds.push(x.sroMasterId);
      });
    }
  }

  loadSelectedAccs() {
    if (this.assignedAccList.length > 0) {
      this.assignedAccList.forEach(x => {
        this.assignedAccessorailMasterIds.push(x.frtAccessorialsId);
      });
    }
  }

  onCycleNameChange(event: any) {
    const cycleName = event.target.value;
    this.bidcycleError = false;
    this.isError = false;
    this.rateBidcyclesList.forEach(bid => {
      if (bid.bidCycleName == cycleName) {
        this.bidcycleError = true;
      }
    });
  }

  bidOpenDateChange(bidOpenDate: any) {
    if (bidOpenDate === null) {
      return;
    }
    const bidCloseDate = this.combineDateandTime();
    const tspOpenDate = this.frtRatesBidcyclesForm.get('tspOpenDate').value;
    this.isError = false;
    this.bidOpenDateError = false;
    this.bidOpenDateErrorType = '';
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (bidOpenDate < today) {
      this.bidOpenDateError = true;
      this.bidOpenDateErrorType = 'A';
    }
    if ((bidCloseDate !== null) &&
      (bidOpenDate > bidCloseDate)) {
      this.bidOpenDateError = true;
      this.bidOpenDateErrorType = 'B';
    }
    if ((bidOpenDate !== '') &&
      (bidCloseDate !== null) &&
      (this.bidOpenDateError == false)) {
      this.rateTypesSroService.getAllRateTypeSrosByBidDate(bidOpenDate, bidCloseDate).subscribe(
        sroListByRateType => {
          this.sroListByRateType = sroListByRateType;
        }, error => {
          this.alertService.error('There was an error retrieving SRO List by Rate Type');
        });
    }
    if ((bidOpenDate !== '') &&
      (tspOpenDate !== '') && (tspOpenDate.setHours(0, 0, 0, 0) < bidOpenDate.setHours(0, 0, 0, 0))) {
      this.tspOpenDateError = true;
      this.tspOpenDateErrorType = 'C';
    } else {
      this.tspOpenDateError = false;
      this.tspOpenDateErrorType = '';
    }
  }

  bidCloseDateChange(bidCloseDate: any) {
    this.frtRatesBidcyclesForm.controls['bidCloseDate'].setValue(bidCloseDate?.detail['value']);
    const currentDate = new Date();
    bidCloseDate = this.combineDateandTime();
    this.showProduction = (currentDate > bidCloseDate);
    if (bidCloseDate === null) {
      return;
    }
    const bidOpenDate = this.frtRatesBidcyclesForm.get('bidOpenDate').value;
    const effOpenDate = this.frtRatesBidcyclesForm.get('effOpenDate').value;
    this.isError = false;
    this.bidCloseDateError = false;
    this.bidCloseDateErrorType = '';
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (bidOpenDate < today) {
      return;
    }
    if (bidCloseDate < today) {
      this.bidCloseDateError = true;
      this.bidCloseDateErrorType = 'A';
    }
    if (bidCloseDate < this.frtRatesBidcyclesForm.get('bidOpenDate').value) {
      this.bidCloseDateError = true;
      this.bidCloseDateErrorType = 'B';
    }
    if (this.frtRatesBidcyclesForm.get('tspCloseDate').value > bidCloseDate) {
      this.tspCloseDateError = true;
      this.tspCloseDateErrorType = 'C';
    } else {
      this.tspCloseDateError = false;
      this.tspCloseDateErrorType = '';
    }
    if ( (effOpenDate !== '' ) && effOpenDate < bidCloseDate) {
      this.effOpenDateError = true;
      this.effOpenDateErrorType = 'B';
    } else {
      this.effOpenDateError = false;
      this.effOpenDateErrorType = '';
    }

    if ((bidCloseDate !== '') &&
      (this.frtRatesBidcyclesForm.get('bidOpenDate').value !== '') &&
      (this.bidCloseDateErrorType == '')) {
      this.rateTypesSroService.getAllRateTypeSrosByBidDate(bidOpenDate, bidCloseDate).subscribe(
        sroListByRateType => {
          this.sroListByRateType = sroListByRateType;
        }, error => {
          this.alertService.error('There was an error retrieving SRO List by Rate Type');
        });
    }
  }

  tspOpenDateChange(tspOpenDate: any) {
    if (!AppConstants.isNotNullCondition(tspOpenDate)) {
      return;
    }
    this.isError = false;
    const tspCloseDate = this.frtRatesBidcyclesForm.get('tspCloseDate').value;
    this.tspOpenDateError = false;
    this.tspOpenDateErrorType = '';
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const bidOpenDate = this.frtRatesBidcyclesForm.get('bidOpenDate').value;
    if (bidOpenDate < today) {
      return;
    }
    if (tspOpenDate < today) {
      this.tspOpenDateError = true;
      this.tspOpenDateErrorType = 'A';
    }
    if ((tspCloseDate !== '') && (tspOpenDate > tspCloseDate)) {
      this.tspOpenDateError = true;
      this.tspOpenDateErrorType = 'B';
    }
    if (tspOpenDate.setHours(0, 0, 0, 0) < bidOpenDate.setHours(0, 0, 0, 0)) {
      this.tspOpenDateError = true;
      this.tspOpenDateErrorType = 'C';
    }
  }

  tspCloseDateChange(tspCloseDate: any) {
    if (tspCloseDate === '' || tspCloseDate === null) {
      return;
    }
    this.isError = false;
    const tspOpenDate = this.frtRatesBidcyclesForm.get('tspOpenDate').value;
    this.tspCloseDateError = false;
    this.tspCloseDateErrorType = '';
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const bidOpenDate = this.frtRatesBidcyclesForm.get('bidOpenDate').value;
    if (bidOpenDate < today) {
      return;
    }
    if (tspCloseDate < today) {
      this.tspCloseDateError = true;
      this.tspCloseDateErrorType = 'A';
    }
    if (tspCloseDate < this.frtRatesBidcyclesForm.get('tspOpenDate').value) {
      this.tspCloseDateError = true;
      this.tspCloseDateErrorType = 'B';
    }
    if (tspCloseDate > this.combineDateandTime()) {
      this.tspCloseDateError = true;
      this.tspCloseDateErrorType = 'C';
    }
  }

  effOpenDateChange(effOpenDate: any) {
    if (effOpenDate === '' || effOpenDate === null) {
      return;
    }
    this.isError = false;
    const bidCloseDate = this.combineDateandTime();
    this.effOpenDateError = false;
    this.effOpenDateErrorType = '';
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const bidOpenDate = this.frtRatesBidcyclesForm.get('bidOpenDate').value;
    if (bidOpenDate < today) {
      return;
    }
    if (effOpenDate < today) {
      this.effOpenDateError = true;
      this.effOpenDateErrorType = 'A';
    }
    if (effOpenDate < bidCloseDate) {
      this.effOpenDateError = true;
      this.effOpenDateErrorType = 'B';
    }
  }

  effCloseDateChange(effCloseDate: any) {
    if (effCloseDate === '' || effCloseDate === null) {
      return;
    }
    this.isError = false;
    const effOpenDate = this.frtRatesBidcyclesForm.get('effOpenDate').value;
    this.effCloseDateError = false;
    this.effCloseDateErrorType = '';
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const bidOpenDate = this.frtRatesBidcyclesForm.get('bidOpenDate').value;
    if (bidOpenDate < today) {
      return;
    }
    if (effCloseDate < today) {
      this.effCloseDateError = true;
      this.effCloseDateErrorType = 'A';
    }
    if ((effOpenDate !== '') && (effCloseDate < effOpenDate)) {
      this.effCloseDateError = true;
      this.effCloseDateErrorType = 'B';
    }
  }

  onPcMilerChange(pcMilerVersion: any) {
    this.frtRatesBidcyclesForm.controls['pcMiler'].setValue(pcMilerVersion);
  }

  onFuelSurChange(fuelSurVersion: any) {
    this.frtRatesBidcyclesForm.controls['fuelSur'].setValue(fuelSurVersion);
  }

  onLtlBase(ltlBaseVer: any) {
    this.frtRatesBidcyclesForm.controls['ltlBase'].setValue(ltlBaseVer);
  }

  onAddlText(addlText: any) {

  }

  onbidCycleNameSelected(selectedBidCycle) {
    this.resetForm();
    this.updateAction = 'update';
    this.updateBtnText = 'Update';
    this.disableCreateBtn = false;
    this.showPublish = false;
    this.clearErrors();
    this.frtRatesBidcyclesForm.controls['ratesBidcyclesId'].setValue(selectedBidCycle.ratesBidcyclesId);
    this.frtRatesBidcyclesForm.controls['bidCycle'].setValue(selectedBidCycle.bidCycleName);
    this.frtRatesBidcyclesForm.controls['bidCycle'].disable();

    let dateString = selectedBidCycle.bidWindowOpenDate;
    const bidWindowOpenDate = new Date(dateString);
    this.frtRatesBidcyclesForm.controls['bidOpenDate'].setValue(bidWindowOpenDate);

    dateString = selectedBidCycle.bidWindowCloseDate;
    const bidWindowCloseDate = new Date(dateString);

    this.frtRatesBidcyclesForm.controls['bidCloseDate'].setValue(moment(bidWindowCloseDate).format('MM/DD/YYYY').toString());
    const currentDate = new Date();
    this.showProduction = (currentDate > this.frtRatesBidcyclesForm.get('bidCloseDate').value) && !(AppConstants.isNotNullCondition(selectedBidCycle.releaseDateProduction));
    this.assignedSroAndAcc(bidWindowOpenDate, bidWindowCloseDate, selectedBidCycle);

    dateString = selectedBidCycle.tspParticipationOpenDate;
    const tspParticipationOpenDate = new Date(dateString);
    this.frtRatesBidcyclesForm.controls['tspOpenDate'].setValue(tspParticipationOpenDate);

    dateString = selectedBidCycle.tspParticipationCloseDate;
    const tspParticipationCloseDate = new Date(dateString);
    this.frtRatesBidcyclesForm.controls['tspCloseDate'].setValue(tspParticipationCloseDate);

    dateString = selectedBidCycle.rateEffectiveDate;
    const rateEffectiveDate = new Date(dateString);
    this.frtRatesBidcyclesForm.controls['effOpenDate'].setValue(rateEffectiveDate);

    dateString = selectedBidCycle.rateExpiryDate;
    const rateExpiryDate = new Date(dateString);
    this.frtRatesBidcyclesForm.controls['effCloseDate'].setValue(rateExpiryDate);

    const intValue = selectedBidCycle.pcMilerVersion;
    const pcMilerVersion = new Number(intValue);
    this.frtRatesBidcyclesForm.controls['pcMiler'].setValue(pcMilerVersion);

    this.frtRatesBidcyclesForm.controls['fuelSur'].setValue(selectedBidCycle.fuelSurchargeVersion);
    this.frtRatesBidcyclesForm.controls['ltlBase'].setValue(selectedBidCycle.ltlBaselineVersion);
    this.frtRatesBidcyclesForm.controls['addlText'].setValue(selectedBidCycle.additionalInformation);
    this.showPublish = selectedBidCycle.publishEmail === 0;
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    this.enableForm();
    if (this.frtRatesBidcyclesForm.controls['bidCloseDate'].value < today) {
      this.disableUpdateButton = true;
      this.disableForm();
    } else {
      this.disableUpdateButton = false;
      // if (this.frtRatesBidcyclesForm.controls['bidOpenDate'].value < today) {
      if (new Date() > this.frtRatesBidcyclesForm.controls['bidOpenDate'].value) {
        this.disablePartialForm();
      }
    }
    this.activateResetBidCycle();
  }

  assignedSroAndAcc(bidWindowOpenDate: Date, bidWindowCloseDate: Date, selectedBidCycle: any) {
    if (AppConstants.isNotNullCondition(bidWindowOpenDate) && AppConstants.isNotNullCondition(bidWindowCloseDate)) {
      this.rateTypesSroService.getAllRateTypeSrosByBidDate(bidWindowOpenDate, bidWindowCloseDate).subscribe(
        sroListByRateType => {
          this.sroListByRateType = sroListByRateType;
        }, error => {
          this.alertService.error('There was an error retrieving SRO List by Rate Type');
        });
    }
    this.assignedSroList = [];
    this.assignedIds = selectedBidCycle.assignedSroMasterIds;
    this.assignedIds.forEach(e => {
      this.populateSelectedSros(e);
    });

    this.frtRatesBidcyclesForm.controls['assignedSros'].setValue(this.assignedSroList);

    this.assignedAccList = [];
    this.assignedIds = selectedBidCycle.assignedAccessorailMasterIds;
    this.assignedIds.forEach(e => {
      this.onAllAccessorialsChange(e);
    });

    this.frtRatesBidcyclesForm.controls['assignedSros'].setValue(this.assignedAccList);
  }

  onDuplicatedBidCycle(selectedBidCycle){
    this.resetForm();
    this.updateBtnText = "Duplicate";
    const bidWindowOpenDate = new Date(selectedBidCycle.bidWindowOpenDate);
    const bidWindowCloseDate = new Date(selectedBidCycle.bidWindowCloseDate);
    this.assignedSroAndAcc(bidWindowOpenDate, bidWindowCloseDate, selectedBidCycle);
    this.showPublish = false;
    this.disableUpdate = false;
    this.showProduction = false;
    this.enableForm();
    this.frtRatesBidcyclesForm.controls['bidCycle'].setValue('');
    this.frtRatesBidcyclesForm.controls['bidCycle'].enable();
    this.frtRatesBidcyclesForm.controls['ratesBidcyclesId'].setValue(0);
  }

  onUpdateFormControlsForDuplicatedBidCycle(selectedBidCycle: any) {
    throw new Error('Method not implemented.');
  }

  disablePartialForm() {
    this.disabled = true;
    this.frtRatesBidcyclesForm.controls['bidCycle'].disable();
    this.frtRatesBidcyclesForm.controls['bidOpenDate'].disable();
    this.frtRatesBidcyclesForm.controls['allSros'].disable();
    this.frtRatesBidcyclesForm.controls['assignedSros'].disable();
    this.frtRatesBidcyclesForm.controls['assignedAccessorials'].disable();
    this.frtRatesBidcyclesForm.controls['allAccessorials'].disable();
    this.frtRatesBidcyclesForm.controls['pcMiler'].disable();
    this.frtRatesBidcyclesForm.controls['fuelSur'].disable();
    this.frtRatesBidcyclesForm.controls['ltlBase'].disable();
    this.clearValidators();
  }

  disableForm() {
    this.disabled = true;
    this.frtRatesBidcyclesForm.controls['bidCycle'].disable();
    this.frtRatesBidcyclesForm.controls['bidOpenDate'].disable();
    this.frtRatesBidcyclesForm.controls['bidCloseDate'].disable();
    // this.frtRatesBidcyclesForm.controls['dateSelection'].disable();
    this.frtBidCycleClosedDate = true;
    this.frtRatesBidcyclesForm.controls['timeSelection'].disable();
    this.frtRatesBidcyclesForm.controls['allSros'].disable();
    this.frtRatesBidcyclesForm.controls['assignedSros'].disable();
    this.frtRatesBidcyclesForm.controls['assignedAccessorials'].disable();
    this.frtRatesBidcyclesForm.controls['allAccessorials'].disable();
    this.frtRatesBidcyclesForm.controls['tspOpenDate'].disable();
    this.frtRatesBidcyclesForm.controls['tspCloseDate'].disable();
    this.frtRatesBidcyclesForm.controls['effOpenDate'].disable();
    this.frtRatesBidcyclesForm.controls['effCloseDate'].disable();
    this.frtRatesBidcyclesForm.controls['pcMiler'].disable();
    this.frtRatesBidcyclesForm.controls['fuelSur'].disable();
    this.frtRatesBidcyclesForm.controls['ltlBase'].disable();
    this.frtRatesBidcyclesForm.controls['addlText'].disable();
    this.clearValidators();
  }

  clearValidators() {
    this.frtRatesBidcyclesForm.controls['bidCycle'].clearValidators();
    this.frtRatesBidcyclesForm.controls['bidOpenDate'].clearValidators();
    this.frtRatesBidcyclesForm.controls['bidCloseDate'].clearValidators();
    this.frtRatesBidcyclesForm.controls['allSros'].clearValidators();
    this.frtRatesBidcyclesForm.controls['assignedSros'].clearValidators();
    this.frtRatesBidcyclesForm.controls['assignedAccessorials'].clearValidators();
    this.frtRatesBidcyclesForm.controls['allAccessorials'].clearValidators();
    this.frtRatesBidcyclesForm.controls['tspOpenDate'].clearValidators();
    this.frtRatesBidcyclesForm.controls['tspCloseDate'].clearValidators();
    this.frtRatesBidcyclesForm.controls['effOpenDate'].clearValidators();
    this.frtRatesBidcyclesForm.controls['effCloseDate'].clearValidators();
    this.frtRatesBidcyclesForm.controls['pcMiler'].clearValidators();
    this.frtRatesBidcyclesForm.controls['fuelSur'].clearValidators();
    this.frtRatesBidcyclesForm.controls['ltlBase'].clearValidators();
    this.frtRatesBidcyclesForm.controls['addlText'].clearValidators();

  }

  enableForm() {
    this.disabled = false;
    this.frtRatesBidcyclesForm.controls['bidOpenDate'].enable();
    this.frtRatesBidcyclesForm.controls['bidCloseDate'].enable();
    this.frtRatesBidcyclesForm.controls['timeSelection'].enable();
    this.frtBidCycleClosedDate = false;
    this.frtRatesBidcyclesForm.controls['allSros'].enable();
    this.frtRatesBidcyclesForm.controls['assignedSros'].enable();
    this.frtRatesBidcyclesForm.controls['assignedAccessorials'].enable();
    this.frtRatesBidcyclesForm.controls['allAccessorials'].enable();
    this.frtRatesBidcyclesForm.controls['tspOpenDate'].enable();
    this.frtRatesBidcyclesForm.controls['tspCloseDate'].enable();
    this.frtRatesBidcyclesForm.controls['effOpenDate'].enable();
    this.frtRatesBidcyclesForm.controls['effCloseDate'].enable();
    this.frtRatesBidcyclesForm.controls['pcMiler'].enable();
    this.frtRatesBidcyclesForm.controls['fuelSur'].enable();
    this.frtRatesBidcyclesForm.controls['ltlBase'].enable();
    this.frtRatesBidcyclesForm.controls['addlText'].enable();
  }

  clearErrors() {
    this.bidcycleError = false;
    this.bidOpenDateError = false;
    this.bidOpenDateErrorType = '';
    this.bidCloseDateError = false;
    this.bidCloseDateErrorType = '';
    this.tspOpenDateError = false;
    this.tspOpenDateErrorType = '';
    this.tspCloseDateError = false;
    this.tspCloseDateErrorType = '';
    this.effOpenDateError = false;
    this.effOpenDateErrorType = '';
    this.effCloseDateError = false;
    this.effCloseDateErrorType = '';
    this.isError = false;
  }

  onAllSrosChange(sroMasterId: any) {
    let rtsPojo: RateTypesSroPojo;
    this.sroListByRateType.forEach(e => {
      if (e.sroMasterId == sroMasterId) {
        rtsPojo = e;
      }
    });

    let itemPresent = false;
    this.assignedSroList.forEach(x => {
      if (x.sroMasterId == sroMasterId) {
        itemPresent = true;
      }
    });
    if (!itemPresent) {
      this.assignedSroList.push(rtsPojo);
    }
  }

  populateSelectedSros(sroMasterId: any) {
    let rtsPojo: RateTypesSroPojo;
    this.allSros.forEach(e => {
      if (e.sroMasterId == sroMasterId) {
        rtsPojo = e;
      }
    });

    let itemPresent = false;
    this.assignedSroList.forEach(x => {
      if (x.sroMasterId == sroMasterId) {
        itemPresent = true;
      }
    });
    if (!itemPresent) {
      this.assignedSroList.push(rtsPojo);
    }
  }

  onAllAccessorialsChange(frtAccessorialsId: any) {
    let accRec: FrtAcessorialsMaster;
    this.frtAccMasterList.forEach(e => {
      if (e.frtAccessorialsId == frtAccessorialsId) {
        accRec = e;
      }
    });

    let itemPresent = false;
    this.assignedAccList.forEach(x => {
      if (x.frtAccessorialsId == frtAccessorialsId) {
        itemPresent = true;
      }
    });
    if (!itemPresent) {
      this.assignedAccList.push(accRec);
    }
  }

  moveItemsSro() {
    const sourceArray = this.frtRatesBidcyclesForm.get('allSros').value;
    const rtsPojoArray: RateTypesSroPojo[] = [];
    const destinationArray = AppConstants.isNotNullCondition(this.assignedSroList) ? this.assignedSroList : [];
    this.sroListByRateType.forEach(e => {
      sourceArray.forEach(y => {
        if (e.sroMasterId === y) {
          rtsPojoArray.push(e);
        }
      });
    });
    this.assignedSroList = Array.from(new Set(destinationArray.concat(rtsPojoArray)));
  }

  moveItems(sourceArray) {
    const accRec: FrtAcessorialsMaster[] = [];
    const destinationArray = this.assignedAccList;
    this.frtAccMasterList.forEach(e => {
      sourceArray.forEach(y => {
        if (e.frtAccessorialsId === y) {
          accRec.push(e);
        }
      });
    });
    this.assignedAccList = Array.from(new Set(destinationArray.concat(accRec)));
  }

  openExtendRates() {
    const initialState = {
      businessType: 'FRT'
    };
    this.modalRef = this.modalService.show(ExtendExpiryDatesComponent, {initialState, backdrop: 'static', class: 'modal-lg'});
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    params.api.sizeColumnsToFit();
  }

  onResetBidCycle(){
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.content.question = 'Are you sure, you want reset the current bidcycle? Click Yes to proceed, No to go back.';
    this.modalRef.content.title = 'Reset the BidCycle';
    this.modalRef.content.confirmText = 'Yes';
    this.modalRef.content.cancelText = 'No';
    this.modalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        this.tmssLoader.show();
        this.frtRatesBidcyclesService.resetBiddCycles(Number(this.frtRatesBidcyclesForm.get('ratesBidcyclesId').value)).subscribe(res => {
          this.tmssLoader.hide();
          this.alertService.success('Resetting a bidcycle is completed');
        }, error => {
          this.tmssLoader.hide();
          this.alertService.error('Error in resetting a bidcycle');
        });
      }
    });
  }

  activateResetBidCycle(){
    this.showResetBidCycle = (location.hostname.includes("preprod") || location.hostname.includes("localhost")) ? true :
      false;
  }

  generateHours(){
    this.listHrs = AppConstants.generateHours();
  }

  initCurrentTime(){
    const initTime = AppConstants.initCurrentTime();
    this.frtRatesBidcyclesForm.get('timeSelection')?.setValue(initTime);
  }

  loadDateandTime(selectedBidCycleCloseddate: any){
    const dateTime = moment(selectedBidCycleCloseddate)
    this.frtRatesBidcyclesForm.get('bidCloseDate')?.setValue(dateTime.format('MM/DD/YYYY').toString());

    this.frtRatesBidcyclesForm.get('timeSelection')?.setValue(AppConstants.initCurrentTime());
  }

  combineDateandTime(){
    var comb = this.frtRatesBidcyclesForm.controls['bidCloseDate'].value + ' ' + this.frtRatesBidcyclesForm.controls['timeSelection'].value;
    return new Date(Date.parse(comb));
  }
}
